import { Component, OnInit,ElementRef,Input,ViewChild,RendererStyleFlags2,Renderer2,ViewChildren,QueryList,Inject} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Location } from '@angular/common';
import { commonsettings } from '../../../data/ezoTempSettings';
import { Subject } from 'rxjs';
import { FormGroup,FormArray,FormBuilder } from '@angular/forms';
import * as title from './../../../data/title.json';
import { Validators } from '@angular/forms';
import { TenantBranchData } from '../../../@core/interfaces/masters/tenantbranch';
import { takeUntil } from 'rxjs/operators';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { BillData } from '../../../@core/interfaces/masters/bill';
import  moment from 'moment'
import { environment } from '../../../../environments/environment';
import { DischargeTmplData } from '../../../@core/interfaces/masters/discharge-tmpl';
import { NbDateService,NbPopoverDirective} from '@nebular/theme';
import { DomSanitizer } from '@angular/platform-browser';
import { PrinterSettingsData } from '../../../@core/interfaces/masters/printersettings';
import { PrintServiceService } from '../../../@theme/components/common/service/print-service.service';
import { DOCUMENT } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxPrintElementService } from 'ngx-print-element';
import { imageatch_detData } from '../../../@core/interfaces/masters/imageatch_det';
import { PdfToBlobService } from '../../pdf-to-blob.service';


@Component({
  selector: 'ngx-opdslip-template-thermal-print',
  templateUrl: './opdslip-template-thermal-print.component.html',
  styleUrls: ['./opdslip-template-thermal-print.component.scss']
})
export class OpdslipTemplateThermalPrintComponent implements OnInit {


  protected readonly unsubscribe$ = new Subject<void>();
  private tenandId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  private createdBy = localStorage.getItem("userId");


srcname= !!localStorage.getItem('TenantHospitalImg')?localStorage.getItem('TenantHospitalImg'):'/assets/images/white.png';
  fontStyleLists=commonsettings.font_style_lists;
  commonSettings=commonsettings.template;
  tempdecSettings=commonsettings.body;

  templateForm:FormGroup;
  fontdialogForm:FormGroup;
  //any used for accessing object value
  templatePreview:any;
  topHeaderLines: FormArray;
  bodyItemLines: FormArray;
  FooterLines: FormArray;
  commonStylechange="";

  pageTitleList:any=[];
  pageTitleSetttings:any=JSON.parse(JSON.stringify(commonsettings.template?.page_title))
  objectKeys = Object.keys;
  itemBodyList:any=[];
  templateData:any;
  visitDate:Date;
  regId: any;

  isSuperAdmin:boolean=localStorage.getItem('isSuperUser')?true:false;

  @ViewChild('printcontent', {static: false}) printcontent: ElementRef;
  @ViewChild('downloadpdf')  downloadpdf: ElementRef;
  downloadHtml='';
  countryDet:any = localStorage.getItem("LoginCountryDet") ? JSON.parse(localStorage.getItem("LoginCountryDet")) : '';
   @Input() timeFormat:string;
  @Input() timeSymbol:string;
  @Input() dateFormatVal:string;
  @Input() patientData;
  @Input() appointmentData;
  @Input() doctorData;
  @Input() appointmentId;
  @Input() departmentvalue;
  @Input() editData;
  @Input() isPageShare;
  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;
  @ViewChildren(NbPopoverDirective) popovers: QueryList<NbPopoverDirective>;
  vitalsData:any;


  loadText:string='';
  cancelDialog:boolean=false;
  changeThemeNotifyDialog:boolean=false;
  onPreviewDialog:boolean=false;
  errorLabel:boolean=false;
  save_discharge_summary:boolean=false;
  update_discharge_summary:boolean=false;
  cancel_summary:boolean=false;

  public config = {
    printMode: 'template-popup',
    popupProperties: 'toolbar=yes,scrollbars=yes,resizable=yes,top=0,left=0,fullscreen=yes',
    pageTitle: 'OP Bill',
    // templateString: '<header>I\'m part of the template header</header>{{printBody}}<footer>I\'m part of the template footer</footer>',
    stylesheets: [{ rel: 'stylesheet', href: '/assets/css/print.css' },{ rel: 'stylesheet', href: '/assets/css/custom.css' },{ rel: 'stylesheet', href: 'https://maxcdn.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css' },
    ],
    styles: [
    commonsettings.printCommonStyle
    ]
  };
  itemvalue:any=[];
  editorConfig: any = {
      width:'auto',
      height: 100,
      plugins:
      'print preview fullpage searchreplace autolink \
       directionality visualblocks visualchars fullscreen \
       image imagetools  media  table template codesample preview \
       charmap hr pagebreak nonbreaking anchor insertdatetime \
       advlist lists textcolor wordcount contextmenu colorpicker textpattern autoresize link image code',
      toolbar:
      'fontselect bold italic forecolor fontsizeselect strikethrough backcolor \
       alignleft aligncenter alignright alignjustify table lineheight \
       numlist bullist outdent indent preview fullscreen code  ',
      image_advtab: true,
      imagetools_toolbar:
      'rotateleft rotateright | flipv fliph | editimage imageoptions',
      toolbar_location: 'bottom',
      statusbar : false,
      toolbar_mode: 'floating',
      menubar:false,
      content_security_policy: "default-src 'self'",
      nonbreaking_force_tab: true,
      setup: function(editor) {
        editor.on('init', function(e) {
        });
      },
      init_instance_callback: function(editor) {
        editor.on('ExecCommand', function(e) {
          if("LineHeight"==e.command){
          }
        });
      }
    // superscript subscript anchor
  };
  titleList: any = (title as any).default;

  constructor(
    private pdfBlobSrvc:PdfToBlobService,
    private iatchSrvc: imageatch_detData,
    private fb: FormBuilder,private renderer: Renderer2,protected tenantBrchSrvc: TenantBranchData,protected psSrvc:PrinterSettingsData,
    protected billData:BillData, public PrintServiceService:PrintServiceService,public spinner:NgxSpinnerService,
    @Inject(DOCUMENT) public document: any,public printsrvc: NgxPrintElementService,
    private dateServices: DateService,public datesrcv:DateService,protected DischargeTmplSrvc: DischargeTmplData,public sanitizer: DomSanitizer, public location:Location,


  ) { 

    this.fontdialogForm = this.fb.group({
      elementVal: this.fb.control(null),
      fontfamily: this.fb.control(this.commonSettings?.fontfamily),
      fontColor: this.fb.control('#333333'),
      fontSize: this.fb.control(12),
      isBold: this.fb.control(false),
      isItalic: this.fb.control(false),
      isUnderline: this.fb.control(false),
      linespace: this.fb.control(1),
      textAlign: this.fb.control("left"),
      outdent: this.fb.control(0),
      indent: this.fb.control(0),
      textheight: this.fb.control(1)
    });
    this.templateForm = this.fb.group({
      //Template prop
      templatename: this.fb.control(null,[Validators.required,],),
      tmplCommonFlag:this.fb.control(null),
      tmplReportHeader:this.fb.control(null),
      tmplReportFooter:this.fb.control("Header"),
      tmplDisplayDept:this.fb.control("Footer"),
      tmplDisplayPhy:this.fb.control(null),
      tmplDisplaySettings:this.fb.control(null),
      tmplActiveFlag:this.fb.control(null),
      ps:this.fb.control('A4',[Validators.required,],),
      orientation:this.fb.control('Portrait',[Validators.required,],),
      lm:this.fb.control(10,[Validators.required],),
      rm:this.fb.control(10,[Validators.required],),
      tm:this.fb.control(10,[Validators.required],),
      bm:this.fb.control(10,[Validators.required],),
      id: this.fb.control(null),
      height: this.fb.control(null),
      width: this.fb.control(null),
      bgColor: this.fb.control('#ffffff'),
      labelColor: this.fb.control('#333333'),
      fontColor: this.fb.control('#333333'),
      fontSize: this.fb.control(12),
      fontfamily: this.fb.control(this.commonSettings?.fontfamily),
      imagewidth: this.fb.control(60),
      temptype: this.fb.control(null),
      //Header
      topHeaderRequired: this.fb.control(true),
      topHeaderLogoRequired: this.fb.control(true),
      topHeaderLogoPosition: this.fb.control('center start'),
      topHeaderPosition: this.fb.control('center end'),
      topHeaderheight: this.fb.control(60),
      topHeaderlineheight: this.fb.control(18),
      topHeaderLines: new FormArray([]),
      topheaderbgColor: this.fb.control('#ffffff'),
      topheaderfontColor: this.fb.control('#333333'),
      topheaderfontfamily: this.fb.control(this.commonSettings?.fontfamily),
      pageTitle: this.fb.control(''),
      pageTitlefontsize: this.fb.control(14),
      reportHeaderPlacement: this.fb.control('center center'),
      pageTitleHeaderRequired: this.fb.control(true),
      //
      pageTitleData: this.fb.control(true),
      // Body Table
      bodyItemLines: new FormArray([]),
      bodyHeader:this.fb.group({
        itemname: this.fb.control(1),
        itemvalue: this.fb.control(null),
        itemfontfamily: this.fb.control(this.commonSettings.fontfamily),
        itemfontcolor: this.fb.control(this.commonSettings.fontColor),
        itemfontsize: this.fb.control(this.commonSettings.fontSize),
        itemisdisplay: this.fb.control(true),
        itemposition: this.fb.control('Left'),
        itemismandatory: this.fb.control(false),
        itemtype: this.fb.control('Body'),
      }),
      bodyValue:this.fb.group({
        itemname: this.fb.control(1),
        itemvalue: this.fb.control(null),
        itemfontfamily: this.fb.control(this.commonSettings.fontfamily),
        itemfontcolor: this.fb.control(this.commonSettings.fontColor),
        itemfontsize: this.fb.control(12),
        itemisdisplay: this.fb.control(true),
        itemposition: this.fb.control('Left'),
        itemismandatory: this.fb.control(false),
        itemtype: this.fb.control('Body'),
      }),

      tblrow: this.fb.control(1),
      tblcol: this.fb.control(1),
      bodylayout: this.fb.control('Top Bottom'),
      //Footer
      FooterRequired: this.fb.control(null),
      FooterLogoRequired: this.fb.control(null),
      FooterLogoPosition: this.fb.control(null),
      FooterPosition: this.fb.control(null),
      Footerheight: this.fb.control(60),
      Footerlineheight: this.fb.control(18),
      FooterLines: new FormArray([]),
      FooterbgColor: this.fb.control('#ffffff'),
      FooterfontColor: this.fb.control('#333333'),
      Footerfontfamily: this.fb.control(this.commonSettings?.fontfamily),
      bottomDocsignrequired: this.fb.control(null),
      bottomDocsignPosition: this.fb.control('center end'),
      bottomDocsignLabel: this.fb.control('Dr Name'),
      bottomDocsignLabelsize: this.fb.control(12),
      bottomDocsignimg: this.fb.control(null),
      bottomDocsignftcol: this.fb.control('#000000'),

      FooterLine1: this.fb.control(null),
      FooterLine2: this.fb.control(null),
      FooterLine3: this.fb.control(null),
      FooterLine4: this.fb.control(null),
      reportHeader: this.fb.control(null),
      reportFooter: this.fb.control(null),
     });
   this.fontdialogForm.valueChanges.subscribe(data => this.onFontDialogValueChanged(data));
  }

  ngOnInit(): void {
    this.fetchBranchDetails()
    this.createbillOPDSlip()
    this.loadPSF()
    this.loadImg()
  }

  pageName:any
  psDetails:any
  billVisibleOption:any
  styleUrl:any
  tenantId:any
  pagename2:any
  loadPSF()
  {
    // call api load printer settings
    this.psSrvc.list(this.tenandId +"/"+this.branchId+ "/printersettings").pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      var ps=data.filter(ps=>ps.pageSetupFor==this.pageName)
      // set printer settings data
      if(ps.length>0){
        this.psDetails=ps[0];
        if(!!this.psDetails?.othersettings)
          this.billVisibleOption=this.PrintServiceService.setVisibleHideOption(JSON.parse(this.psDetails.othersettings));
        else
          this.billVisibleOption=this.PrintServiceService.getPrinterVisibleData("opbill");

          // dynamic set style url based on papper size
          this.styleUrl="/assets/css/print.css,/assets/css/"+(this.psDetails.paperSize).toLowerCase()+(this.psDetails.orientation).toLowerCase()+".css";
          // set header and footer position & required
          this.psDetails=this.PrintServiceService.onSetPsData(this.psDetails);
          this.config=this.PrintServiceService.printConfig(this.psDetails)

          if(this.tenantId==this.PrintServiceService.bloomTID && this.branchId==this.PrintServiceService.bloomBID){
            this.pagename2="Out-Patient Cash Bill/Receipt";
            this.pagename2=this.pagename2.toUpperCase();
          }
          // end
      }else{
          this.psDetails=this.PrintServiceService.onGetPrinterSettings();
          this.config=this.PrintServiceService.printConfig(this.psDetails)
      }

      }, (error) => {
      }, () => {
      });

  }

  // load tenant img  ***********  Raja
  loadImg(){
    this.iatchSrvc.getById(`${environment.apiUrl}/ImageAtchDet/${this.tenandId}/${this.branchId}/all`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      var x =  data.filter(x=>x.phyId==null&&x.empId==null&&x.patId==null&&x.tenantId===this.tenandId)
      this.srcname="../.././../../assets/images/logo.png";
      if(x.length>0)
      {
        x[0].isCreate = true;
        x[0].isEdit = true;
        this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenandId}/${this.branchId}/download`,x[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
        this.srcname = 'data:image/jpeg;base64,' + downloaddata;
        }, (error) => {
        }, () => {
        });
      }
    }, (error) => {
    }, () => {
  });
}

  get fval():{[key: string]: AbstractControl} { return this.templateForm.controls; }
  get fval1():{[key: string]: AbstractControl} { return this.fontdialogForm.controls; }
  get apiUrl() {   return environment.baseUrl;  }
  ngOnChanges(changes: any): void {
    if(this.patientData!=null && this.appointmentId!=null){
      this.getvitalsData(this.patientData.id);
    }
  }
  onChange(args: any ) {
  }
  onFontDialogValueChanged(data){
    if(!!data && !!data.elementVal)
       this.setfontstyle(data);
    if(!!this.commonStylechange){
     this.templatePreview?.bodyItemLines?.forEach(async (x,index) => {
       if(this.commonStylechange=="header"){
         var headerval=this.fontdialogForm.value;
         headerval.elementVal=document.getElementById("itembodyheader"+index) as HTMLElement;
         this.setfontstyle(headerval);
       }
       if(this.commonStylechange=="value"){
         var bodyval=this.fontdialogForm.value;
         bodyval.elementVal=document.getElementById("itembodyvalue"+index) as HTMLElement;
         this.setfontstyle(bodyval);
       }
    });
   }
 }
 getvitalsData(regId){
  this.DischargeTmplSrvc.list("patientvital/" + this.tenandId + "/" +this.branchId + "/" + regId + "/0/getVitalsByApptId/" +  this.appointmentId ).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    this.vitalsData=data?.patientVitals;
    this.visitDate=data?.visitDate
   }, (error) => {
   }, () => {
    if(!!this.editData){
      this.editdata(this.editData)
    }
   });
}
valueChange(value,event,index){
  this.bodyItemLines = this.templateForm.get('bodyItemLines') as FormArray;
  var val=this.bodyItemLines.controls[index].value;
  val.value.itemvalue=value
  this.bodyItemLines.controls[index].setValue(val);
}
setformtewoValue(control,val){
  this.fontdialogForm.controls[`${control}`].setValue(val);
}
 setfontstyle(data){
  const flags = RendererStyleFlags2.DashCase | RendererStyleFlags2.Important;
  this.renderer.setStyle(data?.elementVal, 'color', data?.fontColor, flags);
  this.renderer.setStyle(data?.elementVal, 'font-size', data?.fontSize+'pt', flags);
  this.renderer.setStyle(data?.elementVal, 'font-family', data?.fontfamily, flags);
  this.renderer.setStyle(data?.elementVal, 'font-weight', data?.isBold?'bold':'normal', flags);
  this.renderer.setStyle(data?.elementVal, 'font-style', data?.isItalic?'italic':'normal', flags);
  this.renderer.setStyle(data?.elementVal, 'text-decoration', data?.isUnderline?'underline':'none', flags);
  this.renderer.setStyle(data?.elementVal, 'text-align', data?.textAlign, flags);
  this.renderer.setStyle(data?.elementVal, 'line-height', data?.textheight, flags);
  this.renderer.setStyle(data?.elementVal, 'padding-left', data?.indent+"px", flags);
}
fetchBranchDetails() {
  this.tenantBrchSrvc.list(`${this.tenandId}/tenantbranch`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    var branchData = data.value.filter(x => x.id == this.branchId);
    this.timeFormat = branchData[0].timeFormat;
    this.timeSymbol = branchData[0].timeSymbol;
    this.dateFormatVal =  branchData[0].dateFormatValue;

  }, (error) => {
  }, () => { });
}
async editdata(data){

  this.templateData=data;
  this.templateForm.controls['templatename'].setValue(data?.tmplName);
  this.templateForm.controls['tmplCommonFlag'].setValue(data?.tmplCommonFlag=='Y'?true:false);
  this.templateForm.controls['tmplReportHeader'].setValue(data?.tmplReportHeader);
  this.templateForm.controls['tmplReportFooter'].setValue(data?.tmplReportFooter);
  this.templateForm.controls['tmplDisplayDept'].setValue(data?.tmplDisplayDept=='Y'?true:false);
  this.templateForm.controls['tmplDisplayPhy'].setValue(data?.tmplDisplayPhy=='Y'?true:false);
  this.templateForm.controls['tmplDisplaySettings'].setValue(JSON.parse(data?.tmplDisplaySettings));
  this.templateForm.controls['tmplActiveFlag'].setValue(data?.tmplActiveFlag=='Y'?true:false);
  var template={...JSON.parse(data?.tmplDisplaySettings),
    temp_title:JSON.parse(data?.tempTitle),
    page_title:JSON.parse(data?.pageTitle),
    footer:JSON.parse(data?.footer)}


  this.templateForm.controls['bgColor'].setValue(template?.bgColor);
  this.templateForm.controls['imagewidth'].setValue(template?.imagewidth);
  this.templateForm.controls['ps'].setValue(template?.ps);
  this.templateForm.controls['orientation'].setValue(template?.orientation);
  this.templateForm.controls['tm'].setValue(template?.tm);
  this.templateForm.controls['bm'].setValue(template?.bm);
  this.templateForm.controls['lm'].setValue(template?.lm);
  this.templateForm.controls['rm'].setValue(template?.rm);
  this.templateForm.controls['labelColor'].setValue(template?.labelColor);
  this.templateForm.controls['fontSize'].setValue(template?.fontSize);
  this.templateForm.controls['fontfamily'].setValue(template?.fontfamily);
  this.templateForm.controls['bodylayout'].setValue(template?.bodylayout);
  this.templateForm.controls['temptype'].setValue(template?.temptype);

  this.pageTitleSetttings=template?.page_title,

  this.pageTitleSetttings.fields.forEach(e => {

  });
  this.pageTitleList=template?.page_title?.fields;
  this.pageTitleList=this.pageTitleList?.map(x=>{
    
    if(x.value==='{RegBarcode}'){
      x.name='regbarcode'
    }
    if(x.new!="new" || !!x.value)
    x.value=this.replaceVariableTostring(x.value);
    return {...x}

    
  });

  (this.templateForm.get('bodyItemLines') as FormArray).clear();
  this.bodyItemLines = this.templateForm.get('bodyItemLines') as FormArray;
  var bodyitmes=data?.dischargeTmplDet;
  this.itemvalue=[];
  bodyitmes?.filter(async (x,index)=>{
    var headerjson={
      "itemfontfamily":JSON.parse(x.rowSettings)?.header?.fontstyle?.fontfamily,
      "itemfontcolor":JSON.parse(x.rowSettings)?.header?.fontstyle?.fontColor,
      "itemfontsize":JSON.parse(x.rowSettings)?.header?.fontstyle?.fontSize,
      "itemposition":JSON.parse(x.rowSettings)?.header?.fontstyle?.textAlign,
    }
    var valuejson={
      "itemfontfamily":JSON.parse(x.rowSettings)?.value?.fontstyle?.fontfamily,
      "itemfontcolor":JSON.parse(x.rowSettings)?.value?.fontstyle?.fontColor,
      "itemfontsize":JSON.parse(x.rowSettings)?.value?.fontstyle?.fontSize,
      "itemposition":JSON.parse(x.rowSettings)?.value?.fontstyle?.textAlign,
    }
    var disSummary= x.rowDefaultValue;
    disSummary=this.replaceVariableTostring(disSummary);
    this.itemvalue.push({value:disSummary,displayeditor:false,displaytext:true});
    var headername=!!x?.rowHeader?x?.rowHeader:x?.rowHeaderName
    this.bodyItemLines.push(this.fb.group({
      header:{itemvalue:headername,...JSON.parse(x.rowSettings).header,...headerjson},
      value: {itemvalue:disSummary,...JSON.parse(x.rowSettings).value,...valuejson}
    }));
  });
  this.itemBodyList=[...this.bodyItemLines.value.map((x,index)=>{
    return {
      index:index,...x
    }
  })];
  (this.templateForm.get('topHeaderLines') as FormArray).clear();
  const addressDetail = data?.branchWiseAddressDetail;
     
         if (!addressDetail || Object.keys(addressDetail).length === 0) {
           this.topHeaderLines = this.templateForm.get('topHeaderLines') as FormArray;
           this.topHeaderLines.clear();
         
           template?.temp_title?.topHeaderLines
             ?.filter(x => !!x.name)
             .forEach(x => {
               this.topHeaderLines.push(this.fb.group({
                 name: x.name,
                 value: x.value,
                 fontsize: x.fontsize
               }));
             });
         
           this.FooterLines = this.templateForm.get('FooterLines') as FormArray;
           this.FooterLines.clear();
         
           template?.footer?.bottomLines
             ?.filter(x => !!x.name)
             .forEach(x => {
               this.FooterLines.push(this.fb.group({
                 name: x.name,
                 value: x.value,
                 fontsize: x.fontsize
               }));
             });
         } else {
           this.topHeaderLines = this.templateForm.get('topHeaderLines') as FormArray;
           this.topHeaderLines.clear();
         
           const headerLines = JSON.parse(addressDetail.templateHeaderConfig || '[]');
           headerLines.forEach((line: any) => {
             this.topHeaderLines.push(this.fb.group({
               name: line.name,
               value: line.value,
               fontsize: line.fontsize
             }));
           });
         
           this.FooterLines = this.templateForm.get('FooterLines') as FormArray;
           this.FooterLines.clear();
         
           const footerLines = JSON.parse(addressDetail.templateFooterConfig || '[]');
           footerLines.forEach((line: any) => {
             this.FooterLines.push(this.fb.group({
               name: line.name,
               value: line.value,
               fontsize: line.fontsize
             }));
           });
         }
        
        if(!!template?.temp_title){
          delete template?.temp_title['topHeaderLines']
          for(let x of this.objectKeys(template?.temp_title)){  
            try{
              if(!!this.templateForm.controls[x])
                this.templateForm.controls[x].setValue(template?.temp_title[x])
            }catch(Execption){}
          }
        }
  if(!!template?.footer){
    delete template?.footer['bottomLines']
    for(let x of this.objectKeys(template?.footer)){
      try{
        if(!!this.templateForm.controls[x])
          this.templateForm.controls[x].setValue(template?.footer[x])
      }catch(Execption){}
    }
  }
  this.onPreview();
}
checkpageTitleVisible(){
  var data=this.pageTitleList?.find(x=>x.display==true)
  if(!!data)
    return true;
  else
    return false;
}
opBillWithAmount:any;
createbillOPDSlip() {
  // Transform dates using DateService
  let timeDate = {
    fromDate: this.dateServices.utcFromDate(this.patientData.regDate),
    toDate: this.dateServices.utcToDate(this.patientData.regDate),
    regId: this.patientData.id,
    physicianId: this.doctorData.id
  };

  const endpoint = `PatAppointment/${this.tenandId}/${this.branchId}/getPatientBillsForOPDSlip`;

  this.billData
    .createbillOPDSlip(endpoint, timeDate)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(
      (data: any) => {

        if (data && data.details && Array.isArray(data.details)) {
          let opBillString = data.details
            .map((e) => `Bill Number: ${e.billNumber} / Net Amount: ${e.netAmount}`)
            .join(", ");
          this.opBillWithAmount = opBillString;

        } else {

        }
      },
      (error: any) => {

      }
    );
}
jsontodb(json,values){
  var  template={
   temp_title:{
     topHeaderLogoPosition: "center start",
     topHeaderLogoRequired: true,
     topHeaderPosition: "center end",
     topHeaderRequired: true,
     topHeaderheight: 60,
     topHeaderlineheight: 18,
     topheaderbgColor: null,
     topheaderfontColor: "#333333",
     topheaderfontfamily: null,
     pageTitle: null,
     pageTitleHeaderRequired: true,
     pageTitlefontsize: 14,
     topHeaderLines:[]
     },
   page_title:this.pageTitleSetttings,
   footer:{
         FooterLogoPosition: "center start",
         FooterLogoRequired: false,
         FooterPosition: "center end",
         FooterRequired: false,
         FooterbgColor: null,
         FooterfontColor: "#333333",
         Footerfontfamily: null,
         Footerheight: 60,
         Footerlineheight: 18,
         bottomDocsignLabel: "",
         bottomDocsignLabelsize: 12,
         bottomDocsignPosition: "center end",
         bottomDocsignftcol: null,
         bottomDocsignimg: null,
         bottomDocsignrequired: null,
         bottomLines:[]
   },
   bgColor:     values.bgColor,
   bgimage:     null,
   imagewidth: values.imagewidth,
   bgposition:  null,
   ps: values.ps,
   orientation: values.orientation,
   tm: values.tm,
   bm: values.bm,
   lm: values.lm,
   rm: values.rm,
   bodylayout: values.bodylayout,
   temptype: values.temptype,
   labelColor: values.labelColor,
   fontColor: values.labelColor,
   fontSize: values.fontSize,
   fontfamily: values.fontfamily,
 };
  template.page_title.fields=JSON.parse(JSON.stringify(this.pageTitleList))
 for(let x of this.objectKeys(json.temp_title)){
   try{
   template.temp_title[x]=this.templateForm.controls[x].value
   }catch(Execption){}
 }
 template.temp_title.topHeaderLines=JSON.parse(JSON.stringify(this.topHeaderLines?.value.filter(x=> !!x.name)));
 for(let x of this.objectKeys(json.footer)){
   try{
     template.footer[x]=this.templateForm.controls[x].value
   }catch(Exception){}
 }
 template.footer.bottomLines=JSON.parse(JSON.stringify(this.FooterLines.value.filter(x=> !!x.name)));
 return template;
}
      getPatientAgeByYear(dob,ageResult,dobFlag): any{

    if(dobFlag=="Y"){
    
       var patientDob=new Date(dob);
    
       var Difference_In_Time = Math.abs(Date.now() - patientDob.getTime());
        var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
        var ageValue = Difference_In_Days / 365.25;
         ageValue= Math.trunc(ageValue);
          
      return ageValue+' Y '
    
    }else{
    
    
      if(ageResult!=null){
    
      var patientAgeResult=new Date(ageResult);
    
      var Difference_In_Time = Math.abs(Date.now() - patientAgeResult.getTime());
      var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
      var ageValue = Difference_In_Days / 365.25;
       ageValue= Math.trunc(ageValue); //Get Before Decimal Value
    return ageValue+' Y '
    }else{
      return '-'
    
    }
    } 
   }
   
dateFormat(date: any, args?: any): any {
  let d = new Date(date)
  return moment(d).format('DD/MM/YYYY')
 }
 validUpto(date){
  const targetDate=new Date(date)
  targetDate.setDate(targetDate.getDate() + 15)
  return targetDate
}
replaceVariableTostring(string){
  if(!!string){
  var bmi,bpsysdia;
  var patlastname=!!this.patientData?.lastname?this.patientData?.lastname?.toUpperCase():'';
  var patdata=this.patientData;
  var timeSymbol;
  if(!!this.timeSymbol){
    if(this.timeSymbol == 'am/pm'){
      timeSymbol = 'a';
    }
    else if(this.timeSymbol == 'AM/PM'){
      timeSymbol = 'A';
    }
  }

  if(this.vitalsData?.height!=null && this.vitalsData?.weight!=null){
    let cmtom = this.vitalsData?.height / 100;
    let heightSqr = cmtom * cmtom;
    bmi=Math.round(this.vitalsData?.weight / heightSqr);
  }

  if(this.vitalsData!=null){
    var additionalval;
    var bpsys=this.vitalsData?.bP_Sys!=null?this.vitalsData?.bP_Sys:'';
    var bpdia=this.vitalsData?.bP_Dia!=null?this.vitalsData?.bP_Dia:'';
    if(bpsys!='' && bpdia!=''){
      additionalval=' / ';
    }
    else{
      additionalval='';
    }
    bpsysdia=bpsys + additionalval + bpdia;
  }
  else{
    bpsysdia='';
  }

   string=string.replace((new RegExp("{patientname}", "g")),this.patientData?.firstname.toUpperCase()+" "+patlastname)
  .replace((new RegExp("{patientname2}", "g")),this.patientData?.firstname.toUpperCase()+" "+patlastname)
  .replace((new RegExp("{patientfname}", "g")),this.patientData?.firstname.toUpperCase())
  .replace((new RegExp("{netAmount}", "g")),this.opBillWithAmount)
  .replace((new RegExp("{patientmno}", "g")),this.patientData?.mobile)
  .replace((new RegExp("{patientid}", "g")),this.patientData?.regNum)
  .replace((new RegExp("{RegBarcode}","g")),this.patientData?.regNum?this.patientData?.regNum:'')
  .replace((new RegExp("{docname2}", "g")),this.doctorData?.doctor+this.doctorData?.displayName.toUpperCase() +" ("+this.departmentvalue?.name+")" )
  .replace((new RegExp("{mlcno}", "g")),'')
  .replace((new RegExp("{patientage}", "g")),this.getPatientAgeByDOB(patdata.dob,patdata.ageResult,patdata.dobFlag))
  .replace((new RegExp("{patientgender}", "g")),this.patientData?.gender.toUpperCase())
     .replace((new RegExp("{patientyear}", "g")),this.getPatientAgeByYear(patdata.dob,patdata.ageResult,patdata.dobFlag) )

  .replace((new RegExp("{patientnhid}", "g")),!!patdata.nhid?patdata.nhid:'{patientnhid}')
  .replace((new RegExp("{patientaadharno}", "g")),!!patdata.aaadhar?patdata.aaadhar:'{patientaadharno}')
  .replace((new RegExp("{patienttitle}", "g")),this.getPatientTitle(patdata.title))
  .replace((new RegExp("{patientregdate}", "g")),this.datesrcv.dateUtctoLocal(patdata.regDate,'YYYY/MM/DD'))
  .replace((new RegExp("{patientregdate-DD/MM/YYYY}", "g")), this.datesrcv.dateUtctoLocal(patdata.regDate, 'DD/MM/YYYY'))
  .replace((new RegExp("{patientdob}", "g")), patdata?.dobFlag === 'Y' ? 
      new Intl.DateTimeFormat('en-GB').format(new Date(patdata.dob)) : 
      ' - ')
  


  .replace((new RegExp("{patientemail}", "g")),!!patdata.email?patdata.email:'{patientemail}')
  .replace((new RegExp("{patientdoorno}", "g")),!!patdata.doorno?patdata.doorno:'{patientdoorno}')
  .replace((new RegExp("{patientaddress}", "g")),!!patdata.address1?patdata.address1:'')
  .replace((new RegExp("{patientaddres2}", "g")),!!patdata.address2?patdata.address2:'')
  .replace((new RegExp("{patientcity}", "g")),!!patdata.city?patdata.city:'')
  .replace((new RegExp("{patientpincode}", "g")),!!patdata.pincode?patdata.pincode:'')
  .replace((new RegExp("{frroNo}", "g")),patdata?.frroNumber||'-')

  .replace((new RegExp("{aadharno}", "g")),patdata.aaadhar!=null?patdata.aaadhar:'')
   .replace((new RegExp("{dlnumber}", "g")),patdata.drivingLicenseNumber!=null?patdata.drivingLicenseNumber:'')
   .replace((new RegExp("{abhanumber}", "g")),patdata.nhid!=null?patdata.nhid:'')
   .replace((new RegExp("{occupation}", "g")),patdata.patientOccupation!=null?patdata.patientOccupation:'')

  .replace((new RegExp("{admdocname}", "g")),this.doctorData?.doctor+this.doctorData?.displayName.toUpperCase() )
  .replace((new RegExp("{docname}", "g")),this.doctorData?.doctor+this.doctorData?.displayName.toUpperCase() )
  .replace((new RegExp("{admdocdept}", "g")),this.departmentvalue?.name)
  .replace((new RegExp("{docdept}", "g")),this.departmentvalue?.name)
  .replace((new RegExp("{doccontno}", "g")),this.doctorData?.mobile)
  .replace((new RegExp("{appointmentno}", "g")),this.appointmentData?.tokenNumber!=null?this.appointmentData?.tokenNumber:'')
  .replace((new RegExp("{admdoat}", "g")),this.datesrcv.dateUtctoLocal(this.appointmentData.date,'YYYY/MM/DD'))
  .replace((new RegExp("{admdoat-DD/MM/YYYY}", "g")),this.dateFormat(this.datesrcv.dateUtctoLocal(this.appointmentData.date,'YYYY/MM/DD')))
  .replace((new RegExp("{validupto}", "g")),this.datesrcv.dateUtctoLocal(this.validUpto(this.appointmentData.date),'YYYY/MM/DD'))
  .replace((new RegExp("{validupto-DD/MM/YYYY}", "g")),this.dateFormat(this.datesrcv.dateUtctoLocal(this.validUpto(this.appointmentData.date),'YYYY/MM/DD')))
  .replace((new RegExp("{vitalheight}", "g")),this.vitalsData?.height!=null?this.vitalsData?.height:'')
  .replace((new RegExp("{vitalpulse}", "g")),this.vitalsData?.pulse!=null?this.vitalsData?.pulse:'')
  .replace((new RegExp("{vitalbp}", "g")),bpsysdia)
  .replace((new RegExp("{vitalweight}", "g")),this.vitalsData?.weight!=null?this.vitalsData?.weight:'')
  .replace((new RegExp("{vitaltemparature}", "g")),this.vitalsData?.temp!=null?this.vitalsData?.temp:'')
  .replace((new RegExp("{vitalspo}", "g")),this.vitalsData?.spo2!=null?this.vitalsData?.spo2:'')
  .replace((new RegExp("{vitalbmi}", "g")),bmi!=null?bmi:'')
  .replace((new RegExp("{vitalresp}", "g")),this.vitalsData?.resp_Rate!=null?this.vitalsData?.resp_Rate:'')
  .replace((new RegExp("{visitdate}", "g")),this.visitDate!=null?this.datesrcv.dateUtctoLocal(this.visitDate,'YYYY/MM/DD'):'')
  .replace((new RegExp("{visitdate-DD/MM/YYYY}", "g")),this.visitDate!=null?this.dateFormat(this.datesrcv.dateUtctoLocal(this.visitDate,'YYYY/MM/DD')):'')
  .replace((new RegExp("{visittime}", "g")),this.visitDate!=null?this.datesrcv.dateUtctoLocal(this.visitDate,this.timeFormat == 'hh:mm' ? 'hh:mm '+ (timeSymbol ? timeSymbol : '') : 'HH:mm'):'')
  .replace((new RegExp("{patientguardian}", "g")),!!this.patientData?.parentOrGuardianName?this.patientData?.parentOrGuardianName:'')
  .replace((new RegExp("{formattedVisitdate}", "g")),this.visitDate!=null?this.datesrcv.dateUtctoLocal(this.visitDate,this.dateFormatVal ? this.dateFormatVal : 'YYYY/MM/DD'):'')



  }
  return string;
 }
 getPatientTitle(title){
  return this.titleList?.find(x=>x?.value==title)?.title;
}
 getPatientAgeByDOB(dob,ageResult,dobFlag): any{

  if(dobFlag=="Y"){

     var patientDob=new Date(dob);

     var Difference_In_Time = Math.abs(Date.now() - patientDob.getTime());
      var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
      var ageValue = Difference_In_Days / 365.25;
       ageValue= Math.trunc(ageValue);
      //extract the year, month, and date from user date input
     // var dobYear = patientDob.getFullYear();
      var dobMonth = patientDob.getMonth();
      var dobDate = patientDob.getDate();

      //get the current date from the system
      var now = new Date();
      //extract the year, month, and date from current date
      var currentMonth = now.getMonth();
      var currentDate = now.getDate();

      //get months
      if (currentMonth >= dobMonth)
        //get months when current month is greater
        var monthAge = currentMonth - dobMonth;
      else {
       // yearAge--;
        var monthAge = 12 + currentMonth - dobMonth;
      }

      //get days
      if (currentDate >= dobDate)
        //get days when the current date is greater
        var dateAge = currentDate - dobDate;
      else {
        monthAge--;
        var dateAge = 31 + currentDate - dobDate;

        if (monthAge < 0) {
          monthAge = 11;
        //  yearAge--;
        }
      }
  return ageValue+' Y '+monthAge+' M '+dateAge+' D'

  }else{


    if(ageResult!=null){

    var patientAgeResult=new Date(ageResult);

    var Difference_In_Time = Math.abs(Date.now() - patientAgeResult.getTime());
    var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
    var ageValue = Difference_In_Days / 365.25;
     ageValue= Math.trunc(ageValue); //Get Before Decimal Value

      //extract the year, month, and date from user date input
      var dobYear = patientAgeResult.getFullYear();
      var dobMonth = patientAgeResult.getMonth();
      var dobDate = patientAgeResult.getDate();

      //get the current date from the system
      var now = new Date();
      //extract the year, month, and date from current date
      var currentMonth = now.getMonth();
      var currentDate = now.getDate();

      //get months
      if (currentMonth >= dobMonth)
        //get months when current month is greater
        var monthAge = currentMonth - dobMonth;
      else {
       // yearAge--;
        var monthAge = 12 + currentMonth - dobMonth;
      }

      //get days
      if (currentDate >= dobDate)
        //get days when the current date is greater
        var dateAge = currentDate - dobDate;
      else {
        monthAge--;
        var dateAge = 31 + currentDate - dobDate;

        if (monthAge < 0) {
          monthAge = 11;
        //  yearAge--;
        }
      }
  return ageValue+' Y '+monthAge+' M '+dateAge+' D'
  }else{
    return '-'

  }
  }
 }
 setpragraph(type,value){
  const flags = RendererStyleFlags2.DashCase | RendererStyleFlags2.Important;
  var data_=this.fontdialogForm.controls['elementVal'].value;
  var existdata=JSON.parse(JSON.stringify(data_?.style));
  var margindata=0;
  if(type=="indent"){
    margindata=5;
    if(existdata.paddingLeft!="")
      margindata=(parseInt(existdata.paddingLeft.split("px")[0])+5)
      this.renderer.setStyle(this.fval1?.elementVal.value, 'padding-left', margindata+"px",flags);
  }
  else if(type=="outdent"){
    margindata=parseInt(existdata.paddingLeft.split("px")[0]);
    if(margindata>=0)
      margindata=margindata-5;
    else
      margindata=margindata-5;
      this.renderer.setStyle(this.fval1?.elementVal.value, 'padding-left', margindata+"px",flags);
  }
  if(!!this.commonStylechange)
    this.fontdialogForm.controls['indent'].setValue(margindata);
}
 fontdialog(event,commonStylechange?){
  if(!!commonStylechange)
    this.commonStylechange=commonStylechange;
  else
    this.commonStylechange=null;
  var existdata=JSON.parse(JSON.stringify(event?.style));
  var res=existdata?.color.replace("rgb",'').replace("(",'').replace(')','').split(",").map(Number);

  this.fontdialogForm.setValue({
        "elementVal": event,
        "fontfamily": this.commonSettings.fontfamily,
        "fontColor": rgbToHex(res[0],res[1], res[2]),
        "fontSize": parseInt(existdata?.fontSize.split("pt")[0]),
        "isBold": !!existdata?.fontWeight ? existdata?.fontWeight=="bold"?true:false : false,
        "isItalic": !!existdata?.fontStyle ? existdata?.fontStyle=="italic"?true:false : false,
        "isUnderline": !!existdata?.textDecoration ? existdata?.textDecoration=="underline"?true:false : false,
        "linespace":  !!existdata?.lineHeight ? parseFloat(existdata?.lineHeight) : 1,
        "textAlign": !!existdata?.textAlign ? existdata?.textAlign : "left",
        "outdent": !!existdata.paddingLeft ? (parseInt(existdata.paddingLeft.split("px")[0])):'0',
        "indent": !!existdata.paddingLeft ? (parseInt(existdata.paddingLeft.split("px")[0])) :'0',
        "textheight": !!existdata?.lineHeight ? parseFloat(existdata?.lineHeight) : 1,
   });
   var returndata=this.fontdialogForm.value;
   delete returndata['elementVal'];
   return returndata;
 }
 popoverclose(){
  if(this.popovers){
    this.popovers.forEach(popover => {
      popover.hide();
    });
  }
}
async onPreview(){
  await this.sleep(1000)
  this.templatePreview=this.templateForm.value;
  
  this.pageTitleList.filter(async (x,index)=>{
    var headerval={...x.headerstyle,elementVal:null};
    var headerelem=document.getElementById("pageheaderhead"+index) as HTMLElement;
    if(!!headerelem){
      headerval.elementVal=headerelem;
      this.onFontDialogValueChanged(headerval);
    }
    var bodyval={...x.valuestyle,elementVal:null};
    var bodyelem=document.getElementById("pageheadervalue"+index) as HTMLElement;
    if(!!bodyelem){
      bodyval.elementVal=bodyelem;
      this.onFontDialogValueChanged(bodyval);
    }
  });
  this.templatePreview?.bodyItemLines?.forEach(async (x,index) => {
     var headerval={...x.header.fontstyle,elementVal:null};
     var headerelm=document.getElementById("itembodyheader"+index) as HTMLElement;
     if(!!headerelm){
        headerval.elementVal=headerelm;
        this.onFontDialogValueChanged(headerval);
     }
     var bodyval={...x.value.fontstyle,elementVal:null};
     var bodyelem=document.getElementById("itembodyvalue"+index) as HTMLElement;
     if(!!bodyelem){
        bodyval.elementVal=bodyelem;
        this.onFontDialogValueChanged(bodyval);
     }
  });
}
sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

showPer:boolean=false;
  loadPer:number;
  getMailData(event){
          let data1 = document.getElementById('tempprintpreview');

          this.pdfBlobSrvc.downloadPDFForHims(data1,this.appointmentData?.patientRegistration?.firstname,this.appointmentData?.patientRegistration?.id,this,this.psDetails,`_OPD_Slip_${this.appointmentData?.appointmentId}`,'OPD_Slip','OPD_Slip','Mail',event,'pdf','opd-slip','email');
    }


  getWhatsappData(event){
      let data1 = document.getElementById('tempprintpreview');

      this.pdfBlobSrvc.downloadPDFForHims(data1,this.appointmentData?.patientRegistration?.firstname,this.appointmentData?.patientRegistration?.id,this,this.psDetails,`_OPD_Slip_${this.appointmentData?.appointmentId}`,'OPD_Slip','OPD_Slip','Mail',event,'pdf','opd-slip','whatsapp');

  }
  getSmsData(event){
      let data1 = document.getElementById('tempprintpreview');
      this.pdfBlobSrvc.downloadPDFForHims(data1,this.appointmentData?.patientRegistration?.firstname,this.appointmentData?.patientRegistration?.id,this,this.psDetails,`_OPD_Slip_${this.appointmentData?.appointmentId}`,'OPD_Slip','OPD_Slip','Mail',event,'pdf','opd-slip','sms');

  }

}
export function rgbToHex(r: number, g: number, b: number): string {
  if(!!r && !!g && !!b)
    return `#${[r, g, b].map(x => x.toString(16).padStart(2, "0")).join("")}`;
  else
    return '#333333'
}
